module.exports = __webpack_public_path__ + "static/media/catalyst-bg-2.b824c7a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/catalyst-bg-2.svg
// module id = 1123
// module chunks = 0